import { fetchMenu, fmArchived,fetchMenuAuto, fetchMenuSocial, fetchMenuManual } from "../debug/DebugData";

import { sentryHub, SentryErrorType } from "Utils/sentryHelper";


export function createServer(handler, errorHander) {
    let timerId
    let requestId = 0;
    let onUpdate = handler
    let onError = errorHander

    let createConsumer;
    let sender
    let socketUrl
    let socket


    let reconnectTimeout = 5000

    function connect(url) {
        socketUrl = url
        startDebug()
        checkActionCable()
    }


    function disconnect() {
        closeSocket()
    }



    function checkActionCable() {
        if (window.ActionCable) {
            createConsumer = window.ActionCable.createConsumer.bind(window.ActionCable);

            start()
        } else {
            setTimeout(() => checkActionCable(), 300)
        };
    };



    function start() {
        //console.log("starting socket .............!")



        try {
            closeSocket()
            socket = createConsumer(socketUrl)
            socket.subscriptions.create(
                'LoyaltySystem::MainChannel', {
                connected() {
                    //                    console.log("connect socket .............!")
                    sender = this;
                    updateAllData();
                },
                disconnected: disconnectHandler,
                rejected: errorHandler,
                received: dataHandler
            }
            );
        } catch (e) {
            console.error("Error socket connection " + socketUrl)

        }
    }


    function closeSocket() {
        {
            if (socket) {
                if (timerId) clearInterval(timerId);

                socket.disconnect();
                socket = null;
            }
        }
    }

    function updateAllData() {
        //        console.log("UPDATE ALL DATA");

        try {
            send('fetch_menu');
        } catch (e) {
            console.error("Server| updateAllData: " + e)
            sentryHub.captureException(SentryErrorType.LS_SERVER_ERROR + ": on send fetch_menu:" + JSON.stringify(e));
        }
    }

    function subscribeToCampaign() {
        try {
            send('subscribe_to_campaign');
        } catch (e) {
            console.error("Server| subscribe_to_campaign: " + e)
            sentryHub.captureException(SentryErrorType.LS_SERVER_ERROR + ": on send subscribe_to_campaign:" + JSON.stringify(e));
        }
    }


    function showSocketError(error = 'websocket error') {
        console.error(error);

        sentryHub.captureException(SentryErrorType.LS_SERVER_ERROR + ": " + JSON.stringify(error));
    }


    function disconnectHandler(msg = 'websocket disconnect') {
        console.info("disconnect")
        sentryHub.captureException(SentryErrorType.LS_SERVER_SOCKTED_DISCONNECTED + ": " + JSON.stringify(msg));
        reconnect()

    }


    function reconnect() {
        setTimeout(() => start(), reconnectTimeout)
    }


    function errorHandler(error) {
        if (socket) {
            closeSocket();
            showSocketError(error);
        }
        console.error("socket error")
        //set app status Error
        onError()

    }


    function send(action, data) {
        requestId++;
        data && (data.request_id = requestId);
        sender.perform(action, data);
        return requestId;
    }

    function dataHandler(data) {

        try {

            //            console.log("socket message: " + data)
            if (!socket) {
                closeSocket();
                return;
            }

            const parsedData = typeof data === 'string' || data instanceof String
                ? JSON.parse(data)
                : data;

            if (parsedData.error) {
                showSocketError(parsedData.error);
                closeSocket();
            } else {
                updateState(parsedData);

            }
        } catch {

            console.log("Error: socket dataHandler")

        }
    }



    function updateState(parsedData) {
        sentryHub.addBreadcrumb("socket", parsedData)

        onUpdate(parsedData)
    }



    function startDebug() {

        if (process.env.NODE_ENV !== "development") return

        //onUpdate({ externalWinInfo: { win: 77, playerId: 'KDa***' } })
        // let winCount = 0
        // const interval = setInterval(() => {
        //     winCount++;
        //     let newWin = { userWinInfo: { win: winCount * 5000, winLocal: winCount * 900000 } }

        //     onUpdate(newWin)
        //     if (winCount > 2) {
        //         clearInterval(interval)
        //     }

        // }, 4000)


        window.addEventListener('keydown', (e) => {
            if (e.code === 'KeyJ') {
                //that.send('fetch_menu');
                onUpdate(fetchMenu)
                //onUpdate(fetchMenu1)
            }
            if (e.code === 'KeyA') {
                //that.send('fetch_menu');
                onUpdate(fetchMenuAuto)
                //onUpdate(fetchMenu1)
            }

            

            if (e.code === 'KeyL') {
                console.log("keyL send userWinInfo ");

                onUpdate({ userWinInfo: { win: 0.99, winLocal: 9.99 } })
            }

            if (e.code === 'KeyE') {

                onUpdate({ externalWinInfo: { win: 1, playerId: 'KDa***' } })
            }

            if (e.code === 'KeyM') {

                onUpdate(fetchMenuManual)
            }

            if (e.code === 'KeyS') {

                onUpdate(fetchMenuSocial)
            }


            if (e.code === 'KeyF') {
                console.log("keyF send archived ");
                onUpdate(fmArchived)
            }


        }
        )



    }






    function run() {
        let winCount = 0;
        //const fetchInterval = setInterval(() => {})



        //onUpdate(JSON.stringify(fetchMenu1))


        const interval = setInterval(() => {
            winCount++;
            let newWin = { userWinInfo: { win: 999, winLocal: 100000, isShowed: false } }

            onUpdate(newWin)
            //onUpdate(JSON.stringify(newWin))
            onUpdate(newWin)
            if (winCount > 3) {
                clearInterval(interval)
            }

        }, 1000)

    }
    return { connect, updateAllData, subscribeToCampaign, disconnect }
}